const ChevronUp = (
  <svg
    width="16"
    height="8"
    viewBox="0 0 16 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6666 7.3335L7.99992 0.66683L1.33325 7.3335"
      stroke="#FF007A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ChevronUp;
